module.exports = __webpack_public_path__ + "static/maps-of-meaning-601c6b6cb524d04ccb2f22ba13a99b51.jpg";